import { xeroOnboardingRoutine, xeroAuthRoutine, xeroOriginRoutine, xeroIsXeroLoginRoutine } from './routines'

export default {
  [xeroOnboardingRoutine.TRIGGER](state, payload) {
    state.onboardingData = payload
  },
  [xeroAuthRoutine.TRIGGER](state, payload) {
    state.validationStateCode = payload
  },
  [xeroOriginRoutine.TRIGGER](state, payload) {
    state.xeroOrigin = payload
  },
  [xeroIsXeroLoginRoutine.TRIGGER](state, payload) {
    state.isXeroLogin = payload
  }
}
